export default __webpack_public_path__ + "static/media/index.a0801c2d.png";